import * as actions from "./actions";
import { validateForm } from "./actions";
import Forms from "./forms";
import formsReducer, {
  disableForm,
  enableForm,
  setFormErrors
} from "../lib/formsReducer";
import { Record } from "immutable";

const feature = "auth";

const InitialState = Record({
  forms: new Forms()
});
const initialState = new InitialState();

export default function authReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

  switch (action.type) {
    case actions.LOGIN_START: {
      return disableForm(state, "login");
    }

    case actions.LOGIN_ERROR: {
      state = enableForm(state, "login");
      return setFormErrors(state, "login", action.payload.errors);
    }
  }

  return formsReducer(state, feature, action, Forms);
}



// WEBPACK FOOTER //
// ./src/common/auth/reducer.js